import "./index.es133.js";
import "react";
import "react-dom";
import "./index.es33.js";
import "./index.es134.js";
import { TimeZoneDate as i } from "./index.es506.js";
var u = function u(t) {
    var e = t.getFullYear().toString().padStart(4, "0"),
      o = (t.getMonth() + 1).toString().padStart(2, "0"),
      a = t.getDate().toString().padStart(2, "0");
    return "".concat(e, "-").concat(o, "-").concat(a);
  },
  D = function D(t) {
    var e = new i(),
      o = Number(t.split("-")[0]) || e.getFullYear(),
      a = Number(t.split("-")[1]) || e.getMonth() + 1,
      n = Number(t.split("-")[2]) || e.getDate() - 1,
      r = new Date(new Date((/* @__PURE__ */new Date()).setFullYear(o, a - 1, n)).setHours(0, 0, 0, 0));
    return r.getFullYear() > 9999 && r.setFullYear(9999), r.getFullYear() < 0 && r.setFullYear(0), r;
  },
  d = function d(t, e) {
    return t.getTime() < e.getTime() ? [t, e] : [e, t];
  };
export { u as formatDate, D as getNormalizedDate, d as sortDate };